import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <p className='footer__text'>
      © {new Date().getFullYear()} Usman Ahmed
    </p>
  </footer>
)

export default Footer
